import * as yup from 'yup';

import { ERROR_MESSAGES } from '../sign-up/sign-up.constants';
import { emailExists } from '../auth-service';

export const emailSchema = () => yup.object()
    .shape({
        username: yup
            .string()
            .test('checkEmail', ERROR_MESSAGES.DUPLICATE_EMAIL, (email: string) => emailExists(email).then((res: boolean) => !res))
            .email(ERROR_MESSAGES.INVALID_EMAIL)
            .required(ERROR_MESSAGES.REQUIRED_EMAIL),
    });
